import { useEffect, useRef, useState } from 'react';

/**
 * Observes when an element enters the viewport.
 * once=true disconnects after first intersection (good for lazy-load triggers).
 */
export function useIntersectionObserver({ rootMargin = '0px', threshold = 0, once = false } = {}) {
  const ref = useRef(null);
  const [isIntersecting, setIsIntersecting] = useState(false);
  const observerRef = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsIntersecting(true);
          if (once) observerRef.current?.disconnect();
        } else if (!once) {
          setIsIntersecting(false);
        }
      },
      { rootMargin, threshold }
    );

    observerRef.current.observe(el);
    return () => observerRef.current?.disconnect();
  }, [rootMargin, threshold, once]);

  return [ref, isIntersecting];
}
